import React from "react";

const ModalOpen = ({ setModalOpen }) => {
  return (
    <div
      role="document"
      tabIndex={0}
      className="v-dialog__content v-dialog__content--active"
      style={{ "z-index": "202" }}
    >
      <div
        className="v-dialog box_instant v-dialog--active v-dialog--persistent"
        style={{
          "-webkit-transform-origin": "center center",
          "-ms-transform-origin": "center center",
          "transform-origin": "center center",
          "max-width": "438px",
        }}
      >
        <button
          onClick={() => {
            setModalOpen(false);
            localStorage.setItem("modal", "false");
          }}
          type="button"
          className="v-icon notranslate v-icon--link mdi mdi-close-circle-outline theme--light white--text dialog-close-icon white--text close_instant"
          style={{ "font-size": "30px" }}
        />
        <div
          className="dialog-card v-card v-sheet theme--light white"
          style={{ "border-radius": "10px" }}
        >
          <div className="row dialog-header no-gutters">
            <div
              className="v-window v-item-group theme--dark v-window--show-arrows-on-hover v-carousel v-carousel--hide-delimiter-background"
              style={{ height: "auto" }}
            >
              <div className="v-window__container" style={{ height: "auto" }}>
                <div className="v-window-item">
                  <div
                    className="v-image v-responsive v-carousel__item theme--light"
                    style={{ height: "auto" }}
                  >
                    <div className="v-responsive__content">
                      <div
                        className="v-sheet theme--light transparent"
                        style={{ height: "100%" }}
                      >
                        <div className="row fill-height no-gutters align-center justify-center">
                          <label className="dialog-title text-capitalize d-block full-width white--text primary pa-2 max_height_setting">
                            Important Announcement
                          </label>
                          <div className="pa-0 popupImage col col-12">
                            {" "}
                            <img src="/assets/69342a11ba5b4.jpg" />{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalOpen;
